import React, { useState } from "react";
import { Container, Row, Col, Button, Form, FormGroup, Input, Label, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import AuthService from "../services/authService";

const ForgotPassword = () => {
    const [username, setUsername] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const onChangeUsername = (e) => {
        setUsername(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setMessage("");
        setError("");
        setLoading(true);

        try {
            const response = await AuthService.requestPasswordReset(username);
            if (response) {
                setSuccess(true);
                setMessage('Password reset instructions have been sent to your account.');
            }
        } catch (err) {
            const errorMessage = err.response?.data?.message ||
                err.response?.data?.error ||
                'Failed to send password reset email. Please try again.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
            <Row className="w-100">
                <Col md={{ size: 6, offset: 3 }}>
                    <div className="border rounded p-4 bg-light">
                        <h2 className="text-center mb-4">Forgot Password</h2>
                        <p className="text-center text-muted mb-4">
                            Enter your user name and we'll send you instructions to reset your password.
                        </p>

                        <Form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Label for="username">User Name</Label>
                                <Input
                                    type="text"
                                    name="username"
                                    id="username"
                                    placeholder="Enter your user name"
                                    value={username}
                                    onChange={onChangeUsername}
                                    required
                                    disabled={success}
                                />
                            </FormGroup>

                            {error && (
                                <Alert color="danger">
                                    {error}
                                </Alert>
                            )}

                            {message && (
                                <Alert color="success">
                                    {message}
                                </Alert>
                            )}

                            {!success && (
                                <Button
                                    color="primary"
                                    block
                                    disabled={loading || !username}
                                >
                                    {loading ? 'Sending...' : 'Send Reset Instructions'}
                                </Button>
                            )}

                            <div className="text-center mt-3">
                                <Link to="/login">Back to Login</Link>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default ForgotPassword;
